import { Flex, Paper, SectionTitle, Text } from '@shared/components';

export interface TaskInformationProps {
  content: {
    label: string;
    value: string;
    action?: React.ReactNode;
  }[];
}

export default function TaskInformation(props: Readonly<TaskInformationProps>) {
  const { content } = props;

  return (
    <Paper>
      <Flex
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          p: theme.spacing(6),
          gap: theme.spacing(4),
          borderRadius: theme.shape.rounded(2),
        })}
      >
        <SectionTitle title='Task Information' />
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(2),
          })}
        >
          {content.map(({ label, value, action }) => (
            <Flex sx={(theme) => ({ gap: theme.spacing(6) })} key={label}>
              <Text sx={{ width: '120px' }}>{label}:</Text>
              <Flex sx={(theme) => ({ gap: theme.spacing(2), alignItems: 'center' })}>
                <Text variant='body1Semibold'>{value}</Text>
                {action}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Paper>
  );
}
